import Button from '@mui/material/Button';
import { makeStyles } from '@mui/styles';
import { useIntl } from 'react-intl';
import { Link as RouterLink } from 'react-router-dom';
import { resolvePath, useQuery } from '../../routes';
import { orderConfirmation } from '../../layout/routes';

const useStyles = makeStyles(({
  container: {
    borderRadius: 'border-radius/border-radius-xs',
    borderWidth: 2,
    paddingTop: 16,
    paddingRight: 40,
    paddingBottom: 16,
    paddingLeft: 40,
  },
}));

const ButtonToLicenseManagement = () => {
  const classes = useStyles();
  const intl = useIntl();
  const { queryDictionary } = useQuery();

  const accountId = useQuery().get('accountId');
  return (
    <Button
      id="goto-order-confirmation-page"
      variant="outlined"
      size="large"
      className={classes.container}
      sx={{
        backgroundColor: '#e7e9ef',
        color: '#233145',
        pl: 7.5,
        pr: 7.5,
        mr: 1,
      }}
      component={RouterLink}
      to={resolvePath(orderConfirmation, undefined, {
        ...queryDictionary,
        accountId: Number(accountId),
      }, false)}
    >
      {intl.formatMessage({ id: 'payment_status.button.back_order_confirmation' })}
    </Button>
  );
};

export default ButtonToLicenseManagement;
